import { LoadingPage } from '@src/common/components/LoadingPage';
import { DuplicateOrder } from '@src/orders/DuplicateOrder';
import { useClient } from '@src/orders/hooks/useClient';
import { useOrder } from '@src/orders/hooks/useOrder';
import { useTranslation } from 'react-i18next';

interface Props {
  orderId: string;
}

export const DuplicateOrderLoader = ({ orderId }: Props) => {
  const { t } = useTranslation();
  const { isLoading: isOrderLoading, order } = useOrder({ id: orderId });
  const { isLoading: isClientLoading, client } = useClient({
    id: order?.clientId ?? '',
  });

  if (isOrderLoading || isClientLoading) {
    return <LoadingPage />;
  }

  if (!order || !client) {
    return <>{t('loadingError')}</>;
  }

  return <DuplicateOrder order={order} />;
};
